export default {
  usPricing: true,
  checkoutFormVariant: 'd',
};
